import React from 'react'
import VipLayout from '../../../components/vip/VipLayout'

const BusinessFinancePage: React.FC = () => {
  return (
    <VipLayout>
      <main>
        <section className="hero">
          <div className="container">
            <span className="kicker">Business & Finance</span>
            <h1>企业工商财税咨询</h1>
            <p>围绕企业设立、变更、注销、财税咨询与基础合规事项，提供更清晰的路径判断、材料准备与流程辅导服务。</p>
            <div className="anchor-nav">
              <a href="#registration">公司注册</a>
              <a href="#change">变更与注销</a>
              <a href="#tax">财税咨询</a>
              <a href="#compliance">基础合规</a>
            </div>
          </div>
        </section>
        <section className="section" id="registration">
          <div className="container two-col">
            <div>
              <h2 className="section-title">公司注册与主体设立</h2>
              <p className="section-desc">适用于创业团队、新设业务主体、业务拆分或新项目落地场景。</p>
            </div>
            <div className="card content-card">
              <ul className="list">
                <li>企业主体形式选择建议</li>
                <li>经营范围规划建议</li>
                <li>注册材料清单与流程辅导</li>
                <li>主体设立后的基础事项提醒</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="section" id="change">
          <div className="container two-col">
            <div className="card content-card">
              <ul className="list">
                <li>股东、法人、地址等变更咨询</li>
                <li>营业执照注销路径建议</li>
                <li>关联材料与顺序安排建议</li>
                <li>企业状态恢复 / 规范化建议</li>
              </ul>
            </div>
            <div>
              <h2 className="section-title">变更、注销与主体调整</h2>
              <p className="section-desc">帮助企业在经营过程中处理主体信息变化与存量主体优化问题。</p>
            </div>
          </div>
        </section>
        <section className="section" id="tax">
          <div className="container">
            <h2 className="section-title">财税咨询</h2>
            <div className="grid cols-3" style={{marginTop: '24px'}}>
              <div className="card content-card">
                <h3>财税基础咨询</h3>
                <p className="lead" style={{fontSize: '15px'}}>围绕企业财税规范、基本税务问题与经营结构提供咨询建议。</p>
              </div>
              <div className="card content-card">
                <h3>业务模式与税务影响判断</h3>
                <p className="lead" style={{fontSize: '15px'}}>结合互联网、SaaS、内容、AI 服务模式理解税务处理差异。</p>
              </div>
              <div className="card content-card">
                <h3>配套服务边界提醒</h3>
                <p className="lead" style={{fontSize: '15px'}}>如涉及代理记账，应当由具备相应资格的机构依法开展。</p>
              </div>
            </div>
          </div>
        </section>
        <section className="section" id="compliance">
          <div className="container card content-card">
            <h2 className="section-title" style={{marginTop: 0}}>企业基础合规支持</h2>
            <p className="section-desc">围绕企业主体、业务模式、资质前置条件、线上服务形态等，帮助客户在后续 ICP / EDI、AI 备案或内容资质申请前建立更稳固的基础主体条件。</p>
          </div>
        </section>
      </main>
    </VipLayout>
  )
}

export default BusinessFinancePage
